import { render, staticRenderFns } from "./AccountingMenu.vue?vue&type=template&id=97b5830e"
import script from "./AccountingMenu.vue?vue&type=script&lang=js"
export * from "./AccountingMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountingMenu.vue?vue&type=style&index=0&id=97b5830e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports